import { Trash2 } from "lucide-react";
import type { FC } from "react";
import type { GoalActionDialog } from "web_myplann/Goals/Hooks/useGoalActions";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ConfirmDrawer } from "web_myplann/Shared/Components/ConfirmDrawer";
import { DeleteItemDrawer } from "web_myplann/Shared/Components/DeleteItemDrawer";

type Props = {
	dialog: GoalActionDialog;
	goalName: string;
	isChangingState: boolean;
	isDeleting: boolean;
	onComplete: () => void;
	onReactivate: () => void;
	onDelete: () => void;
	onCancel: () => void;
};

export const GoalActionDialogs: FC<Props> = ({
	dialog,
	goalName,
	isChangingState,
	isDeleting,
	onComplete,
	onReactivate,
	onDelete,
	onCancel,
}) => {
	const { t } = useResource();

	return (
		<>
			<ConfirmDrawer
				open={dialog === "complete"}
				title={t(Resources.Goals.Detail.Actions.Complete.title)}
				description={t(Resources.Goals.Detail.Actions.Complete.description, {
					name: goalName,
				})}
				confirmLabel={t(Resources.Goals.Detail.Actions.Complete.confirm)}
				cancelLabel={t(Resources.Goals.Detail.Actions.Complete.cancel)}
				isPending={isChangingState}
				onClose={onCancel}
				onConfirm={onComplete}
			/>
			<ConfirmDrawer
				open={dialog === "reactivate"}
				title={t(Resources.Goals.Detail.Actions.Reactivate.title)}
				description={t(Resources.Goals.Detail.Actions.Reactivate.description, {
					name: goalName,
				})}
				confirmLabel={t(Resources.Goals.Detail.Actions.Reactivate.confirm)}
				cancelLabel={t(Resources.Goals.Detail.Actions.Reactivate.cancel)}
				isPending={isChangingState}
				onClose={onCancel}
				onConfirm={onReactivate}
			/>
			<DeleteItemDrawer
				open={dialog === "delete"}
				itemTitle={goalName}
				namespace={Resources.Goals.Detail.Delete}
				Icon={Trash2}
				isPending={isDeleting}
				onClose={onCancel}
				onConfirm={onDelete}
			/>
		</>
	);
};
